<template>
<div class="data-map-container">
  <div ref="data-map-inner" class="data-map-inner">
    <a-map ref="map" :features="['bg', 'road', 'point']" map-style="normal" />
    <ul v-if="trjtype === 1" class="legend-list">
      <li
        v-for="(data, index) in dataList"
        :key="index"
        :style="{
        '--legend-section-color': data.style.line.color
      }"
      >
        <section class="legend-section"></section>
        <span>{{data.name}}</span>
      </li>
    </ul>
  </div>

  <div v-if="dataList.length > 0 && showChart" class="chart-wrapper">
    <e-chart ref="chart" />
  </div>
</div>
</template>

<script>
import * as EventKeyMap from '../../../../components/Map/EventKeys'

import BaseHySplit from './BaseHySplit'

import AMap from '../../../../components/Map/index'
import EChart from '../../../../components/Charts/ECharts'

export default {
  name: 'MapView',
  extends: BaseHySplit,
  components: {EChart, AMap},
  props: {
    dataList: {
      required: true,
      type: Array
    },
    trjtype: {
      required: true
    }
  },
  computed: {
    siteId () {
      return this.model.siteId
    },
    showChart () {
      return this.model.showChart
    },
    hideNotSelectedSite () {
      return this.model.hideNotSelectedSite
    }
  },
  methods: {
    createText (map, site) {
      let {siteId} = this
      let isCurrent = siteId === site.id
      let text = map.createText({
        text: `<div class="map-site-name-text" style="--site-bg:${isCurrent ? '#409eff' : '#00e400'}">${site.name}</div>`,
        position: map.createLngLat(site.longitude, site.latitude),
        style: {
          'font-size': '14px',
          padding: '0 0 6px 0',
          border: 0,
          'background': 'transparent',
          color: '#fff'
        },
        clickable: true,
        topWhenClick: true,
        extData: site
      })

      if (isCurrent) {
        text.setTop(true)
      } else if (this.hideNotSelectedSite) {
        text.hide()
      }

      text.on('click', this.onSiteClick)

      return text
    },
    updateSiteBgColor (newSiteId, oldSiteId) {
      let {siteTexts} = this

      if (!siteTexts) {
        return
      }

      let {hideNotSelectedSite} = this

      let currentSite = siteTexts[newSiteId]

      if (currentSite) {
        let site = currentSite.getExtData()
        currentSite.setText(`<div class="map-site-name-text" style="--site-bg:#409eff">${site.name}</div>`)
        currentSite.setTop(true)

        if (hideNotSelectedSite) {
          currentSite.show()

          let {longitude, latitude} = currentSite.getExtData()
          let {map} = this
          map.panTo(map.createLngLat(longitude, latitude))
        }
      }

      let lastSite = siteTexts[oldSiteId]

      if (lastSite) {
        let site = lastSite.getExtData()
        lastSite.setText(`<div class="map-site-name-text" style="--site-bg:#00e400">${site.name}</div>`)
        lastSite.setTop(false)

        if (hideNotSelectedSite) {
          lastSite.hide()
        }
      }
    },
    renderSites (sites) {
      this.clearSites()

      if (!Array.isArray(sites) || sites.length === 0) {
        return
      }

      let {map} = this

      if (!map) {
        return
      }

      let {createText} = this

      map.setFitView(Object.values(this.siteTexts = sites.reduce((siteTextMap, site) => {
        siteTextMap[site.id] = createText(map, site)
        return siteTextMap
      }, {})))
    },
    renderLines (dataList) {
      this.clearLines()

      if (!Array.isArray(dataList) || dataList.length === 0) {
        return
      }

      let {map} = this

      if (!map) {
        return
      }

      let {createLngLat} = map

      this.lines = dataList.map(data => map.createPolyline({
        showDir: true,
        strokeColor: data.style.line.color,
        strokeWeight: 4,
        path: [...data.points].sort((a, b) => a.time.getTime() - b.time.getTime()).map(point => createLngLat(...point.lngLat)),
        zIndex: 999
      }))

      map.setFitView(this.lines)
    },
    renderChart (dataList) {
      if (this.showChart) {
        setTimeout(() => {
          if (!Array.isArray(dataList) || dataList.length === 0) {
            let {chart} = this.$refs

            if (chart) {
              chart.clear()
            }

            return
          }

          let chartOpt = {
            legend: {
              show: this.trjtype === 1,
              top: 10,
              textStyle: {
                color: '#ffffff'
              }
            },
            tooltip: {
              appendToBody: true,
              // trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: 'rgba(0,0,0,.55)'
                }
              }
            },
            grid: {
              top: 40,
              right: 60,
              bottom: 20,
              left: 40,
              containLabel: true
            },
            yAxis: {
              name: '垂直高度(米)',
              nameLocation: 'middle',
              nameGap: 55,
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#ffffff'
                }
              }
            },
            xAxis: {
              type: 'category',
              data: dataList[0].points.map(point => point.time.format('YYYY-MM-DD HH')),
              axisLine: {
                lineStyle: {
                  color: '#ffffff'
                }
              }
            },
            series: dataList.map(data => ({
              name: data.name,
              type: 'line',
              data: data.points.map(point => point.value),
              showSymbol: false,
              color: data.style.line.color
            }))
          }

          this.$refs.chart.setOpt(chartOpt)
        }, 100)
      }
    },
    onSiteClick (event) {
      this.$emit('site-click', event.target.getExtData())
    },
    clearSites () {
      let {siteTexts} = this

      if (!siteTexts) {
        return
      }

      Object.values(siteTexts).forEach(text => {
        text.off('click', this.onSiteClick)
        text.setMap(null)
      })

      this.siteTexts = null
    },
    clearLines () {
      let {lines} = this

      if (!Array.isArray(lines)) {
        return
      }

      lines.forEach(line => {
        line.setMap(null)
      })
    },
    clear () {
      this.clearSites()
      this.clearLines()
    },
    onMapCreated (map) {
      this.map = map
      let {dataList} = this
      this.renderSites(this.profileSites)
      this.renderLines(dataList)
      this.renderChart(dataList)
    },
    onMapDestroy () {
      this.$destroy()
    }
  },
  watch: {
    profileSites (sites) {
      this.renderSites(sites)
    },
    siteId (newSiteId, oldSiteId) {
      this.updateSiteBgColor(newSiteId, oldSiteId)
    },
    hideNotSelectedSite (hideNotSelectedSite) {
      let {siteTexts} = this

      if (!siteTexts) {
        return
      }

      let siteTextList = Object.values(siteTexts)

      if (hideNotSelectedSite) {
        siteTextList.forEach(siteText => {
          siteText.hide()
        })

        let currentSite = siteTexts[this.siteId]

        if (currentSite) {
          currentSite.show()
        }
      } else {
        siteTextList.forEach(siteText => {
          siteText.show()
        })
      }
    },
    dataList (dataList) {
      this.renderLines(dataList)
      this.renderChart(dataList)
    },
    showChart () {
      this.renderChart(this.dataList)
    }
  },
  mounted () {
    let {$eventBus} = this
    $eventBus.once(EventKeyMap.MAP_CREATED, this.onMapCreated)
    $eventBus.once(EventKeyMap.MAP_DESTROY, this.onMapDestroy)
  },
  beforeDestroy () {
    this.clear()
  }
}
</script>

<style lang="scss" scoped>
.data-map-container {
  position: relative;

  .data-map-inner {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .legend-list {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0 6px 0 0;
    list-style: none;
    z-index: 999;
    pointer-events: none;

    > li {
      font-size: 12px;
      display: grid;
      grid-template-columns: 1em max-content;
      grid-column-gap: 5px;
      align-items: center;
      line-height: 20px;

      > section {
        height: 1em;
        background-color: var(--legend-section-color);
      }
    }
  }

  > .chart-wrapper {
    position: absolute;
    right: 0;
    bottom: 10px;
    left: 0;
    width: 85%;
    height: 250px;
    margin: 0 auto;
    border: {
      radius: 10px;
    }
    background-color: rgba(0, 21, 62, .5);
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/MapView.vue